/*
	payment/common/lib/utils/dispatcher

	Only named functions with unique name can be registered.
*/

const callback = [];

function isRegistered(cb) {
	/* The some() method tests whether some element in the array passes the test implemented by the provided function.
	the function compares the equality of two functions after convertion to strings. This was introduced since the compressionstep
	during buildprocess deleted the name info.  */
	return callback.some((value, key) => {
		return callback[key].toString() === cb.toString();
	});
}

function dispatch(payload) {
	callback.forEach((cb) => {
		cb(payload);
	});
}

export {
	dispatch
};

export default {
	register(cb) {
		if (!isRegistered(cb)) {
			callback.push(cb);
		}
		return callback.length;
	},
	unregister(index) {
		delete callback[index];
	},
	dispatch(payload) {
		function handler(cb) {
			cb(payload);
		}
		callback.forEach(handler);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/dispatcher.js